export enum QuizStage {
    Viewing = '',
    Answering = 'ANSWER',
    Results = 'RESULTS',
}
